/**
 * 必須チェック処理
 * @param {*} val 値
 * @param {*} name 名称
 * @param {*} id ID
 * @param {*} errors エラーリスト
 * @param {*} cannotZero ゼロを許可しないかどうか
 */
export function checkRequired(val, name, id, errors, cannotZero = false) {
  if (cannotZero && val == 0) {
    errors.push({ msg: `・${name}を入力してください。`, fields: [id] });
    return;
  }
  if (!val?.toString().trim()) {
    errors.push({ msg: `・${name}を入力してください。`, fields: [id] });
  }
}
